module.exports = __webpack_public_path__ + "static/20180910_121503-8bdf2ad3001659426af8dc610db590db.jpg";